import { Component, Inject, ViewContainerRef } from '@angular/core';
import { ToasterService } from '../../_screens/_shared/toaster/toaster.service';

@Component({
    selector: 'jhi-main',
    templateUrl: './main.component.html',
})
export class JhiMainComponent {
    constructor(
        @Inject(ToasterService) toastService,
        @Inject(ViewContainerRef) viewContainerRef
    ) {
        toastService.setRootViewContainerRef(viewContainerRef);
    }
}



// WEBPACK FOOTER //
// ./src/app/layouts/main/main.component.ts